import TakeawayWaiting from '../../components/TakeawayWaiting'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    takeawayOrders: state.basket.takeawayOrders,
    basket: state.basket,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TakeawayWaiting))



// WEBPACK FOOTER //
// ./src/containers/components/TakeawayWaiting.js